import React from 'react';

const RequestNavigationContext = React.createContext({
  setActiveTab: () => {},
  activeTab: '',
});

export default RequestNavigationContext;
